import { render, staticRenderFns } from "./item-list.vue?vue&type=template&id=0b6c6d7e&scoped=true"
import script from "./item-list.vue?vue&type=script&lang=js"
export * from "./item-list.vue?vue&type=script&lang=js"
import style0 from "./item-list.vue?vue&type=style&index=0&id=0b6c6d7e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6c6d7e",
  null
  
)

export default component.exports